import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Grid, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
;
export const Error = memo(({ error = 'You are not authenticated.', }) => (_jsxs(Grid, { container: true, spacing: 1, direction: 'column', alignItems: 'center', justifyContent: 'center', style: { height: '100vh', }, children: [_jsx(Grid, { item: true, children: _jsx(Typography, { variant: 'h6', children: error }) }), _jsx(Grid, { item: true, children: _jsx(ErrorOutlineIcon, { color: 'error', fontSize: 'large' }) })] })));
